import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { CID } from 'multiformats/cid';
import varint from 'varint';
import { decode as decodeMultiHash } from 'multiformats/hashes/digest';
export function readVarint(bytes) {
  var value = varint.decode(bytes);
  var readLength = varint.decode.bytes;
  var remainder = bytes.slice(readLength);
  return [value, remainder, readLength];
}
function isCidVersion(input) {
  return input === 0 || input === 1;
}
export function readCid(bytes) {
  var result = readCidNoThrow(bytes);
  if (result instanceof Error) {
    throw result;
  }
  return result;
}
export function readCidNoThrow(bytes) {
  var _readVarint = readVarint(bytes),
    _readVarint2 = _slicedToArray(_readVarint, 2),
    cidVersion = _readVarint2[0],
    cidVersionRemainder = _readVarint2[1];
  if (!isCidVersion(cidVersion)) {
    return new Error("Unknown CID version ".concat(cidVersion));
  }
  var _readVarint3 = readVarint(cidVersionRemainder),
    _readVarint4 = _slicedToArray(_readVarint3, 2),
    codec = _readVarint4[0],
    codecRemainder = _readVarint4[1];
  var _readVarint5 = readVarint(codecRemainder),
    _readVarint6 = _slicedToArray(_readVarint5, 3),
    mhCodecRemainder = _readVarint6[1],
    mhCodecLength = _readVarint6[2];
  var _readVarint7 = readVarint(mhCodecRemainder),
    _readVarint8 = _slicedToArray(_readVarint7, 3),
    mhLength = _readVarint8[0],
    mhLengthLength = _readVarint8[2];
  var multihashBytes = codecRemainder.slice(0, mhCodecLength + mhLengthLength + mhLength);
  var multihashBytesRemainder = codecRemainder.slice(mhCodecLength + mhLengthLength + mhLength);
  return [CID.create(cidVersion, codec, decodeMultiHash(multihashBytes)), multihashBytesRemainder];
}